import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

export default function MainDashboard() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);


 
  return (
    <>
      <div className="mainDiv">
      <Typography className="heading">Welcome to kahay faqeer admin panel</Typography>
      </div>
    </>
  );
}
